/* Cart offer step: shown after Check out for company buyers.
   Content comes from sections/cart-offers.liquid via the Section Rendering API. */
(function () {
  if (window.__cartOffersInit) return;
  window.__cartOffersInit = true;

  var SEEN_KEY = 'cartOffersSeenV2'; var SEEN_TTL = 30 * 60 * 1000;
  var CHECKOUT_SELECTOR = '#CartDrawer-Checkout, #checkout, button[name="checkout"]';
  var state = { screens: [], index: 0, panel: null, moneyFormat: '${{amount}}', tiers: [0, 5, 7, 10] };

  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }

  function seen() {
    try { var d = JSON.parse(localStorage.getItem(SEEN_KEY) || 'null'); if (!d || !d.t || Date.now() - d.t > SEEN_TTL) return []; return d.keys || []; } catch (e) { return []; }
  }

  function markSeen(key) {
    try {
      var list = seen();
      if (list.indexOf(key) === -1) list.push(key);
      var prev = null; try { prev = JSON.parse(localStorage.getItem(SEEN_KEY) || 'null'); } catch (e2) { prev = null; } var t = (prev && prev.t && Date.now() - prev.t <= SEEN_TTL) ? prev.t : Date.now(); localStorage.setItem(SEEN_KEY, JSON.stringify({ t: t, keys: list }));
    } catch (e) {}
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return state.moneyFormat
      .replace('{{amount_with_comma_separator}}', withDots + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', withDots)
      .replace('{{amount_no_decimals}}', withCommas)
      .replace('{{amount}}', withCommas + '.' + parts[1]);
  }

  function goCheckout() {
    window.location.href = (window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/\/cart$/, '') : '') + '/checkout';
  }

  function refreshCart() {
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) {
      if (typeof el.onCartUpdate === 'function') el.onCartUpdate();
    });
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = state.panel && state.panel.querySelector('[data-offers-total]');
        if (total) total.textContent = formatMoney(cart.total_price);
      })
      .catch(function () {});
  }

  function buildPanel() {
    var panel = document.createElement('div');
    panel.className = 'cart-offers';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Offers before checkout');
    panel.innerHTML =
      '<div class="cart-offers__overlay" data-offers-close></div>' +
      '<div class="cart-offers__panel">' +
      '<div class="cart-offers__top">' +
      '<button type="button" class="cart-offers__back" data-offers-close>\u2190 Back to cart</button>' +
      '<span class="cart-offers__count" data-offers-count></span>' +
      '</div>' +
      '<div class="cart-offers__dots" data-offers-dots></div>' +
      '<div class="cart-offers__body" data-offers-body></div>' +
      '<div class="cart-offers__foot">' +
      '<div class="cart-offers__total">Estimated total<strong data-offers-total></strong></div>' +
      '<button type="button" class="cart-offers__skip" data-offers-skip>Skip to checkout \u2192</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(panel);
    return panel;
  }

  function open(dataEl) {
    state.moneyFormat = dataEl.dataset.moneyFormat || state.moneyFormat;
    state.tiers = (dataEl.dataset.tiers || '0,5,7,10').split(',').map(Number);

    var done = seen();
    var screens = Array.prototype.slice.call(dataEl.querySelectorAll('.cart-offers__screen')).filter(function (s) {
      return done.indexOf(s.dataset.offerKey) === -1;
    });
    if (!screens.length) { goCheckout(); return; }

    if (!state.panel) state.panel = buildPanel();
    var body = state.panel.querySelector('[data-offers-body]');
    body.innerHTML = '';
    screens.forEach(function (s) { body.appendChild(s); });
    state.screens = screens;
    state.index = 0;
    state.panel.querySelector('[data-offers-total]').textContent = dataEl.dataset.cartTotal || '';

    var dots = state.panel.querySelector('[data-offers-dots]');
    dots.innerHTML = screens.map(function () { return '<span></span>'; }).join('');

    document.documentElement.classList.add('cart-offers-open');
    state.panel.classList.add('is-open');
    track('offer_step_start', { offer_count: screens.length });
    show(0);
  }

  function close() {
    if (!state.panel) return;
    state.panel.classList.remove('is-open');
    document.documentElement.classList.remove('cart-offers-open');
  }

  function show(i) {
    state.index = i;
    state.screens.forEach(function (s, n) { s.hidden = n !== i; });
    state.panel.querySelector('[data-offers-count]').textContent = 'Offer ' + (i + 1) + ' of ' + state.screens.length;
    state.panel.querySelectorAll('[data-offers-dots] span').forEach(function (d, n) {
      d.classList.toggle('is-done', n <= i);
    });
    var screen = state.screens[i];
    update(screen);
    track('offer_view', { offer_key: screen.dataset.offerKey, position: i + 1 });
    var heading = screen.querySelector('.cart-offers__heading');
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    state.panel.querySelector('.cart-offers__panel').scrollTop = 0;
  }

  function next() {
    if (state.index + 1 < state.screens.length) show(state.index + 1);
    else goCheckout();
  }

  function selected(screen) {
    return Array.prototype.slice.call(screen.querySelectorAll('[data-select][aria-pressed="true"]:not(.is-locked)'));
  }

  function update(screen) {
    var picks = selected(screen);
    var cta = screen.querySelector('[data-offer-accept]');
    var key = screen.dataset.offerKey;

    if (key === 'complete_system') {
      var inCart = Number(screen.dataset.inCart || 0);
      var n = inCart + picks.length;
      var pct = state.tiers[Math.min(n, 3)] || 0;
      screen.querySelectorAll('[data-tier]').forEach(function (t) {
        var tier = Number(t.dataset.tier);
        t.classList.toggle('is-current', tier === n);
        t.classList.toggle('is-past', tier < n);
      });
      screen.querySelectorAll('.cart-offers__row').forEach(function (row) {
        var label = row.querySelector('[data-price-label]');
        var price = Number(row.dataset.price || 0);
        var on = row.getAttribute('aria-pressed') === 'true';
        if (on && pct) {
          label.innerHTML = '<s>' + formatMoney(price) + '</s><strong>' + formatMoney(Math.round(price * (100 - pct) / 100)) + '</strong>';
        } else {
          label.textContent = formatMoney(price);
        }
      });
      if (picks.length) {
        cta.disabled = false;
        cta.textContent = 'Add ' + picks.length + (picks.length === 1 ? ' item' : ' items') + ' \u2014 save ' + pct + '% on ' + n;
      } else {
        cta.disabled = true;
        cta.textContent = 'Select items to add';
      }
      return;
    }

    if (picks.length) {
      cta.textContent = 'Continue \u00b7 ' + picks.length + ' added';
      cta.classList.remove('button--tertiary');
    } else {
      cta.textContent = 'No thanks';
      cta.classList.add('button--tertiary');
    }
    screen.querySelectorAll('[data-select]').forEach(function (b) {
      if (b.tagName === 'BUTTON' && !b.classList.contains('cart-offers__row')) {
        var on = b.getAttribute('aria-pressed') === 'true';
        b.textContent = on ? '\u2713 Added' : '+ Add';
        var holder = b.closest('.cart-offers__tile, .cart-offers__step');
        if (holder) holder.classList.toggle('is-selected', on);
      }
    });
  }

  function reloadRemaining() { fetch('/cart?section_id=cart-offers', { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) { var data = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-offers__data'); var done = seen(); var current = state.screens[state.index]; var fresh = data ? Array.prototype.slice.call(data.querySelectorAll('.cart-offers__screen')).filter(function (s) { return done.indexOf(s.dataset.offerKey) === -1 && (!current || s.dataset.offerKey !== current.dataset.offerKey); }) : []; var body = state.panel.querySelector('[data-offers-body]'); state.screens.slice(state.index + 1).forEach(function (s) { s.remove(); }); fresh.forEach(function (s) { body.appendChild(s); }); state.screens = state.screens.slice(0, state.index + 1).concat(fresh); var dots = state.panel.querySelector('[data-offers-dots]'); dots.innerHTML = state.screens.map(function () { return '<span></span>'; }).join(''); next(); }).catch(function () { next(); }); }  function accept(screen) {
    var key = screen.dataset.offerKey;
    var picks = selected(screen);
    markSeen(key);
    if (!picks.length) { track('offer_skip', { offer_key: key, skip_type: 'no_thanks' }); next(); return; }

    var cta = screen.querySelector('[data-offer-accept]');
    cta.disabled = true;
    cta.setAttribute('aria-busy', 'true');

    var items = picks.map(function (b) {
      return { id: Number(b.dataset.select), quantity: 1, properties: { _offer: key } };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status >= 400) throw new Error(res.description || 'Cart error');
        track('offer_add', { offer_key: key, item_count: items.length, variant_ids: items.map(function (i) { return i.id; }).join(',') });
        refreshCart(); reloadRemaining(); return;
        next();
      })
      .catch(function () {
        cta.disabled = false;
        cta.removeAttribute('aria-busy');
        var err = screen.querySelector('.cart-offers__error');
        if (!err) {
          err = document.createElement('p');
          err.className = 'cart-offers__error';
          err.setAttribute('role', 'alert');
          cta.parentNode.insertBefore(err, cta);
        }
        err.textContent = 'Something went wrong adding these items. Please try again.';
      });
  }

  /* Intercept Check out */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest(CHECKOUT_SELECTOR);
    if (!btn || btn.dataset.offersBypass === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart?section_id=cart-offers', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        btn.removeAttribute('aria-busy');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var data = doc.querySelector('.cart-offers__data');
        if (!data || Number(data.dataset.offerCount || 0) === 0) { goCheckout(); return; }
        open(data);
      })
      .catch(function () { goCheckout(); });
  }, true);

  /* Panel interactions */
  document.addEventListener('click', function (event) {
    if (!state.panel || !state.panel.contains(event.target)) return;

    if (event.target.closest('[data-offers-close]')) { close(); return; }

    if (event.target.closest('[data-offers-skip]')) {
      state.screens.forEach(function (s) { markSeen(s.dataset.offerKey); });
      track('offer_skip', { offer_key: (state.screens[state.index] || {}).dataset ? state.screens[state.index].dataset.offerKey : '', skip_type: 'skip_to_checkout' });
      goCheckout();
      return;
    }

    var screen = event.target.closest('.cart-offers__screen');
    if (!screen) return;

    var pick = event.target.closest('[data-select]');
    if (pick && !pick.classList.contains('is-locked')) {
      pick.setAttribute('aria-pressed', pick.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      if (pick.classList.contains('cart-offers__row')) pick.classList.toggle('is-selected');
      update(screen);
      return;
    }

    if (event.target.closest('[data-offer-decline]')) {
      markSeen(screen.dataset.offerKey);
      track('offer_skip', { offer_key: screen.dataset.offerKey, skip_type: 'no_thanks' });
      next();
      return;
    }

    if (event.target.closest('[data-offer-accept]')) accept(screen);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && state.panel && state.panel.classList.contains('is-open')) close();
  });
})();
